import { render } from "./NavHome.vue?vue&type=template&id=4af0668b&scoped=true"
const script = {}

import "./NavHome.vue?vue&type=style&index=0&id=4af0668b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af0668b"]])

export default __exports__